import { DELETE_REQUEST_ATTACHMENT } from "../../../enums/Request/request.types";

export const newDeleteAttachmentAction = (data) => {
    return {
        type: DELETE_REQUEST_ATTACHMENT,
        payload: data,
    };
};
